import React from 'react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import './Vision.css';

interface VisionItem {
  id: number;
  icon: string;
  title: string;
  subtitle: string;
  description: string;
}

const Vision: React.FC = () => {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.2 });

  const visionItems: VisionItem[] = [
    {
      id: 1,
      icon: '🎯',
      title: '愿景',
      subtitle: '让推动摇篮的手推动世界',
      description: '我们相信，通过艺术心理教育，可以从源头上改善每个家庭的心理健康，让每一个孩子都能在充满爱与关怀的环境中成长。',
    },
    {
      id: 2,
      icon: '💝',
      title: '使命',
      subtitle: '提升全民心灵幸福指数',
      description: '通过专业的艺术心理疗法和教育服务，帮助更多个人和家庭获得心理健康支持，提升整体幸福感。',
    },
    {
      id: 3,
      icon: '⭐',
      title: '价值观',
      subtitle: '成就他人，服务社会',
      description: '以专业的态度、真诚的关怀和创新的方法，为每一位客户提供优质的心理健康服务，为社会创造积极的价值。',
    },
  ];

  return (
    <section id="vision" className="vision">
      <div className="vision-container" ref={ref}>
        <div className={`section-header ${isVisible ? 'visible' : ''}`}>
          <h2 className="section-title">企业战略</h2>
          <p className="section-subtitle">
            我们的愿景、使命与价值观
          </p>
        </div>

        <div className="vision-grid">
          {visionItems.map((item, index) => (
            <div
              key={item.id}
              className={`vision-card ${isVisible ? 'visible' : ''}`}
              style={{ transitionDelay: `${index * 0.2}s` }}
            >
              <div className="vision-icon-wrapper">
                <div className="vision-icon">{item.icon}</div>
              </div>
              <h3 className="vision-title">{item.title}</h3>
              <h4 className="vision-subtitle">{item.subtitle}</h4>
              <p className="vision-description">{item.description}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Vision;
